import { useQuery } from '@tanstack/react-query';
import { adminApi } from '../../../api/adminApi';
import { useAdminStore } from '../../../store/adminStore';
import DataTable from '../common/DataTable';
import StatusBadge from '../common/StatusBadge';
import CopyButton from '../common/CopyButton';
import './TransactionsPanel.css';

export default function TransactionsPanel() {
    const { transactionFilters, setTransactionFilters } = useAdminStore();

    const { data: transactions, isLoading } = useQuery({
        queryKey: ['transactions', transactionFilters],
        queryFn: () => adminApi.getTransactions(transactionFilters),
        refetchInterval: 15000,
    });

    const handleFilterChange = (key: string, value: string) => {
        setTransactionFilters({ ...transactionFilters, [key]: value });
    };

    const columns = [
        {
            header: 'TX Hash',
            accessor: (tx: any) => (
                <div className="tx-hash-cell">
                    <span className="truncate">{tx.txHash}</span>
                    <CopyButton text={tx.txHash} />
                    <a
                        href={`https://tronscan.org/#/transaction/${tx.txHash}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="explorer-link"
                    >
                        ↗
                    </a>
                </div>
            ),
        },
        {
            header: 'Type',
            accessor: (tx: any) => (
                <span className={`tx-type type-${tx.type.toLowerCase()}`}>
                    {tx.type}
                </span>
            ),
        },
        {
            header: 'Amount',
            accessor: (tx: any) => (
                <span className={`amount-cell ${tx.type === 'INCOMING' ? 'positive' : 'negative'}`}>
                    {tx.type === 'INCOMING' ? '+' : '-'}${tx.amount.toLocaleString()}
                </span>
            ),
        },
        {
            header: 'Network',
            accessor: 'network',
        },
        {
            header: 'Status',
            accessor: (tx: any) => <StatusBadge status={tx.status} />,
        },
        {
            header: 'Time',
            accessor: (tx: any) => new Date(tx.createdAt).toLocaleString(),
        },
    ];

    return (
        <div className="transactions-panel">
            <div className="filters-bar glass">
                <div className="filter-group">
                    <select
                        value={transactionFilters.type || ''}
                        onChange={(e) => handleFilterChange('type', e.target.value)}
                        className="filter-select"
                    >
                        <option value="">All Types</option>
                        <option value="INCOMING">Incoming</option>
                        <option value="OUTGOING">Outgoing</option>
                        <option value="FEE">Fee</option>
                    </select>

                    <select
                        value={transactionFilters.network || ''}
                        onChange={(e) => handleFilterChange('network', e.target.value)}
                        className="filter-select"
                    >
                        <option value="">All Networks</option>
                        <option value="TRON">Tron</option>
                        <option value="ETHEREUM">Ethereum</option>
                        <option value="SOLANA">Solana</option>
                    </select>
                </div>
            </div>

            <DataTable
                data={transactions || []}
                columns={columns}
                keyField="id"
                isLoading={isLoading}
                emptyMessage="No transactions found."
            />
        </div>
    );
}
